import React from 'react';
import './HomepageButton.css';

function HomepageButton({ title, onClick = () => {}, style }) {
  return (
    <button
      className="homepage-button"
      type="button"
      onClick={onClick}
      style={{ ...style }}
    >
      {title}
    </button>
  );
}

export default HomepageButton;
